<template lang="pug">
    el-dialog(title="添加队伍",:fullscreen="false",:visible.sync="visible" width="80%" :append-to-body='true' :modal-append-to-body='false' @close="closeForm()")
        el-row
            el-col(:span="12")
                el-card(shadow="never")
                    div(slot="header")
                        el-row
                            el-col(:span='22')
                                el-input(v-model='clubName' clearable='', style='width:80%;' placeholder="请输入俱乐部名称/会长/手机号码")
                            el-col(:span='2')
                                el-button(@click="sizeChangeHandle" style='float:right;' icon='el-icon-search') 查询
                    div
                        el-table(:data="leftData" ref='leftData' @row-click="currentClickLeft" border v-el-table-infinite-scroll="currentChangeHandle" max-height="300" highlight-current-row @select="handleCurrentChangeLeft" )
                            //- el-table(:data="leftData"  row-key="id" ref='leftData' border v-el-table-infinite-scroll="currentChangeHandle"  @selection-change="checkLeftAll" max-height="300" highlight-current-row @select="handleCurrentChangeLeft" )
                            el-table-column(prop="name" label="俱乐部" align='center')
                            el-table-column(prop="chairman" label="会长" align='center'  )
                            el-table-column(prop="chairmanId" label="手机号码" align='center' )
                            //- el-table-column(type="selection" align='center' reserve-selection=true)
                            el-table-column(header-align='center' label='序号' align='center'  width='80')
                                template(scope="scope")
                                    el-radio(class="radio" v-model="radio" :label="scope.$index+1")
                    //-   el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
            el-col(:span="12")
                el-card(shadow="never")
                    div(slot="header")
                        font.font_label 当前俱乐部的会员
                    div
                        el-table(ref="memberTable" row-key="id" :data="rightData" v-el-table-infinite-scroll="currentChangeHandleRight" border @selection-change="checkRightAll" max-height="317")
                            el-table-column(type="selection" align='center' reserve-selection=true)
                            el-table-column(prop="name" label="姓名" align='center')
                                template(slot-scope="scope")
                                    font {{scope.row.name||scope.row.nickname}}
                            el-table-column(prop="gender" label="性别" align='center' )
                                template(slot-scope="scope")
                                    font(v-if="scope.row.gender === 0") 男
                                    font(v-if="scope.row.gender === 1") 女
                            el-table-column(prop="level" label="级别" align='center' )
                            el-table-column(prop="mobile" label="手机号码" align='center' )
                        //- el-pagination(@size-change='sizeChangeHandleRight', @current-change='currentChangeHandleRight', :current-page='pageIndexRight', :page-sizes='[10, 20, 50, 100]', :page-size='pageSizeRight', :total='totalPageRight', layout='total, sizes, prev, pager, next, jumper')
        span.dialog-footer(slot="footer")
            el-button(@click="addEnroll" type="primary") 确 定
            el-button(@click="visible=false") 取 消
</template>
<script>
export default {
  data () {
    return {
      visible: false,
      radio: '',
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      pageIndexRight: 1,
      pageSizeRight: 10,
      totalPageRight: 0,
      ruleForm: {},
      clubName: '',
      leftData: [],
      rightData: [], // 右边列表
      selectDataLeft: [], // 左边选中列表数据
      selectDataRight: [], // 右边选中列表数据
      selectDataRightAll: [], //右侧选择的所有俱乐部的会员
      currentRowLeft: {}, //当前选择的俱乐部
      currentRowRight: {}, //当前选择的会员
      enrollValidateClub: false, //俱乐部参赛信息验证
      enrollValidateMember: false, //俱乐部会员参赛信息验证
      selectEnrollData: {}, //选中的报名队伍
      enrollData: [],
      enrollList: {}

    }
  },
  methods: {
    openFullScreen () {
      this.loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    //刷新添加人员左边table
    init (ruleForm, enrollData) {
        this.visible = true
        this.pageIndex = 1
        if (ruleForm) {
          this.ruleForm = ruleForm
        }
        this.clubName = ''
        this.leftData = []
        this.rightData = []
        this.enrollData = enrollData
        this.selectDataLeft = []// 左侧选中列表数据
        this.selectDataRight = [] // 右边选中列表数据
        this.selectDataRightAll = []
        this.enrollList = {}
        this.enrollList.ctId = this.ruleForm.id
        this.getLeftData()
    },
    getLeftData () {
        console.log('已报名俱乐部', this.enrollData)
        let cbIds = []
        if (this.enrollData && this.enrollData.length > 0) {
            this.enrollData.forEach(e => {
                cbIds.push(e.participantInfoId)
            })
        }
        console.log('当前页：', this.pageIndex, Math.ceil(this.totalPage / this.pageSize))
        this.$http({
            url: this.$http.adornUrl(`/cbClub/getClubPageList`),
            method: 'GET',
            params: this.$http.adornParams({
                'page': this.pageIndex,
                'rows': this.pageSize,
                'name': this.clubName,
                'niIds': cbIds.join(',')
            })
        }).then(data => {
            if (data && data.code === 0) {
                if (this.pageIndex === 1) {
                    this.leftData = data.page.rows
                } else {
                    this.leftData = this.leftData.concat(data.page.rows)
                }
                this.totalPage = data.page.total
            } else {
                this.leftData = []
                this.totalPage = 0
            }
            // console.log("俱乐部列表：",this.leftData)
        })
    },
    //根据已选中的俱乐部初始化俱乐部的会员信息
    getRightData () {
        if (!this.currentRowLeft.id) {
            return
        }
        this.$http({
            url: this.$http.adornUrl(`/mbMember/getClubMbListByCbId`),
            method: 'GET',
            params: this.$http.adornParams({
                'page': this.pageIndexRight,
                'rows': this.pageSizeRight,
                'cbId': this.currentRowLeft.id
            })
        }).then(data => {
            console.log('选中俱乐部的会员列表：', data)
            if (data && data.code === 0) {
                let arr = data.page.rows.filter(item => {
                    return item.teamLeader !== 1
                })
                if (this.pageIndexRight === 1) {
                    this.rightData = arr
                } else {
                    this.rightData = this.rightData.concat(arr)
                }
                this.totalPageRight = data.page.total
                let selectedMb = []
                //根据已选择的所有俱乐部的会员信息，初始化勾选当前俱乐部的会员表
                if (this.selectDataRightAll && this.selectDataRightAll.length > 0) {
                    // console.log("已选择的所有俱乐部的会员：",this.selectDataRightAll)
                    this.selectDataRightAll.forEach(e => {
                        if (e.cbId === this.currentRowLeft.id) {
                            // console.log("当前俱乐部id，this.currentRowLeft.id,cbId==",this.currentRowLeft.id,cbId)
                            this.rightData.forEach(b => {
                                if (e.id === b.id) {
                                    // console.log("当前俱乐部id，b.id,mbId==",b.id,mbId)
                                    // console.log("this.$refs.memberTable==",this.$refs.memberTable)
                                    selectedMb.push(b)
                                    // this.$refs.memberTable.toggleRowSelection(b,true);
                                    // console.log("右侧已选数据",this.selectDataRight)
                                }
                            })
                        }
                    })
                }
                if (selectedMb && selectedMb.length > 0) {
                    console.log('当前俱乐部已选择的会员：', selectedMb)
                    selectedMb.forEach(row => {
                        this.$refs.memberTable.toggleRowSelection(row, true)
                    })
                    // this.selectDataRight = selectedMb;
                } else {
                    this.$refs.memberTable.clearSelection()
                }
            } else {
                this.rightData = []
                this.totalPageRight = 0
            }
        })
    },
    //验证俱乐部信息
    checkClubByCbIds (dataList) {
        let cbIds = []
        if (dataList && dataList.length > 0) {
            dataList.forEach(e => {
                cbIds.push(e.id)
            })
        } else {
            return
        }
        this.$http({
            url: this.$http.adornUrl(`/elEnroll/checkClubByCbIds`),
            method: 'GET',
            params: this.$http.adornParams({
                'ctId': this.ruleForm.id,
                'cbIds': cbIds.join(',')
            })
        }).then(data => {
            console.log('选择俱乐部的验证结果：', data)
            if (data && data.code === 0) {
                if (!data.state) {
                    this.$message.error(data.info)
                    this.enrollValidateClub = false
                } else {
                    this.enrollValidateClub = true
                }
            }
        })
    },
    //验证会员信息
    checkMemberByMbIds (mbIds) {
        this.$http({
            url: this.$http.adornUrl(`/elEnroll/checkMemberByMbIds`),
            method: 'GET',
            params: this.$http.adornParams({
                'ctId': this.ruleForm.id,
                'cbId': this.currentRowLeft.id,
                'totalMbIds': mbIds.join(','),
                'mbIds': mbIds.join(',')
            })
        }).then(data => {
            console.log('选择俱乐部会员的验证结果：', data)
            if (data && data.code === 0) {
                if (!data.state) {
                    this.$message.error(data.info)
                    this.enrollValidateClub = false
                } else {
                    this.enrollValidateClub = true
                }
            }
        })
    },

    // 每页数
    sizeChangeHandle (val) {
        this.pageSize = 10
        this.pageIndex = 1
        this.getLeftData()
    },
    // 点击当前俱乐部
    currentClickLeft (val) {
        //赋值给radio
        this.radio = this.leftData.indexOf(val) + 1
        this.currentRowLeft = val
        this.selectDataRightAll = []
        this.getRightData()
    },
    // 当前页
    currentChangeHandle (val) {
        let flag = true
        if (this.pageIndex) {
            if (this.pageIndex < Math.ceil(this.totalPage / this.pageSize)) {
                this.pageIndex++
            } else {
                flag = false
            }
        } else {
            this.pageIndex = 1
        }
        if (flag) {
            this.getLeftData()
        }
    },
    checkLeftAll (val) {
        // console.log("选择的俱乐部：",val)
        this.selectDataLeft = val
        this.checkClubByCbIds(this.selectDataLeft)
    },
    //俱乐部列表选中事件
    handleCurrentChangeLeft (selection, val) {
        console.log('选中了当前俱乐部**********：', selection, val)
        this.selectDataLeft = selection
        let flag = false
        selection.forEach(e => {
            if (e === val) {
                flag = true
            }
        })
        if (flag) {
            this.currentRowLeft = val
            this.pageIndexRight = 1
            this.getRightData()
        }
    },
    // 每页数
    sizeChangeHandleRight (val) {
        this.pageSizeRight = 10
        this.pageIndexRight = 1
        this.getRightData()
    },
    // 当前页
    currentChangeHandleRight (val) {
        let flag = true
        if (this.pageIndexRight) {
            if (this.pageIndexRight < Math.ceil(this.totalPageRight / this.pageSize)) {
                this.pageIndexRight++
            } else {
                flag = false
            }
        } else {
            this.pageIndexRight = 1
        }
        if (flag) {
            this.getRightData()
        }
    },
    checkRightAll (val) {
        console.log(this.selectDataRightAll, '选择的所有俱乐部的会员1：')
        //选择俱乐部的会员
        this.selectDataRight = val
        let mbIds = []//当前俱乐部选择的会员id
        console.log('已选择的会员--=====：', this.selectDataRight)
        this.removeMbByCbId()//先将当前俱乐部选择的会员全部移除
        if (this.selectDataRight && this.selectDataRight.length > 0) {
          this.selectDataRight.forEach(e => {
              mbIds.push(e.id)
              console.log('已选择的会员------------：', e.id)
              let va = { 'id': e.id, 'cbId': this.currentRowLeft.id }
              let existsFlag = false
              if (this.selectDataRightAll && this.selectDataRightAll.length > 0) {
                  this.selectDataRightAll.forEach(a => {
                      if (a.id === e.id) {
                          existsFlag = true
                      }
                  })
              }
              if (!existsFlag) {
                  this.selectDataRightAll.push(va)
              }
          })
          this.checkMemberByMbIds(mbIds)
        }
        console.log(this.selectDataRightAll, '选择的所有俱乐部的会员2：')
    },
    getIndexFromArr (arr, object) {
      for (let i in arr) {
        if (arr[i].id === object.id) {
          return i
        }
      }
    },
    removeMbByCbId () {
      //当前俱乐部没有选择任何会员，则将所有俱乐部选择的会员变量中移除当前俱乐部的会员
      if (this.selectDataRightAll && this.selectDataRightAll.length > 0) {
          this.selectDataRightAll.forEach(a => {
              if (a.cbId === this.currentRowLeft.id) {
                  this.selectDataRightAll.splice(this.getIndexFromArr(this.selectDataRightAll, a), 1)
              }
          })
      }
    },
    //添加参赛队伍入库
    addEnroll () {
        if (this.selectDataRightAll.length === 0) {
            this.$message.error('没有要添加的队伍!')
        } else if (this.selectDataRightAll.length > 0) {
            console.log('要提交的队伍信息：', this.selectDataRightAll)
            this.enrollList.ctId = this.ruleForm.id
            this.enrollList.mbMemberList = this.selectDataRightAll
            let cbIds = []
            cbIds.push(this.currentRowLeft.id)
            // if (this.selectDataLeft && this.selectDataLeft.length > 0) {
            //     this.selectDataLeft.forEach(e => {
            //         cbIds.push(e.id)
            //     })
            // } else {
            //     return
            // }
            this.$http({
                url: this.$http.adornUrl(`/elEnroll/checkClubByCbIds`),
                method: 'GET',
                params: this.$http.adornParams({
                    'ctId': this.ruleForm.id,
                    'cbIds': cbIds.join(',')
                })
            }).then(data => {
                console.log('选择俱乐部的验证结果：', data)
                if (data && data.code === 0) {
                    if (!data.state) {
                        this.$message.error(data.info)
                    } else {
                        let mbIds = []
                        this.selectDataRightAll.forEach(e => {
                            if (e.cbId === this.currentRowLeft.id) {
                                mbIds.push(e.id)
                            }
                        })

                        this.$http({
                            url: this.$http.adornUrl(`/elEnroll/checkMemberByMbIds`),
                            method: 'GET',
                            params: this.$http.adornParams({
                                'ctId': this.ruleForm.id,
                                'totalMbIds': mbIds.join(','),
                                'mbIds': mbIds.join(',')
                            })
                        }).then(data => {
                            console.log('选择俱乐部会员的验证结果：', data)
                            if (data && data.code === 0) {
                                if (!data.state) {
                                    this.$message.error(data.info)
                                } else {
                                    this.openFullScreen()
                                    this.$http({
                                        url: this.$http.adornUrl(`/elEnroll/saveEnrollClub`),
                                        method: 'post',
                                        data: this.enrollList
                                    }).then(data => {
                                        console.log(data)
                                        if (data && data.code === 0) {
                                            if (!data.state) {
                                                this.$message.error(data.info)
                                            } else {
                                                this.$message.success('添加成功!')
                                                this.visible = false
                                                this.$emit('refreshDataList')
                                            }
                                        }
                                        this.loading.close()
                                    })
                                }
                            }
                        })
                    }
                }
            })
        }
    },

    closeForm () {
      this.visible = false
    }

  }
}
</script>
